import Pasadena1 from '../../../Media/Ruko Paramount/Pasadena/Pasadena.webp'
import Pasadena2 from '../../../Media/Ruko Paramount/Pasadena/Pasadena.webp'

const Pasadenaimages =[
Pasadena1,Pasadena2
]

export default Pasadenaimages;
